var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-visual"
  }, [_c('video', {
    staticClass: "main-visual__video",
    attrs: {
      "src": "/videos/main-visual.mp4",
      "autoplay": "",
      "muted": "",
      "preload": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }), _c('v-container', [_c('v-row', {
    staticClass: "row--xl"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    staticClass: "main-visual__logo",
    attrs: {
      "src": "/images/main/visual/main-visual-logo.svg",
      "alt": "REBORN BIOME"
    }
  })], 1), _c('v-col', {
    staticClass: "text-center white--text",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit mb-3 mb-md-4"
  }, [_vm._v("20년 노하우로 만든 건강, 리본바이옴")]), _c('v-row', {
    staticClass: "row--xs txt txt--lg white--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("리본바이옴은 20년간 인류의 장 건강을 연구해온 프로바이오틱스 전문 브랜드입니다.")]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("엄격한 품질기준과 최신 과학으로 건강한 삶의 가치를 전합니다. (주)리본바이옴은 20년 전통의 프로바이오틱스 전문 제조사 ‘㈜웰빙엘에스’의 공식 판매·유통 자회사입니다.")]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("리본바이옴 사이트에서 제공되는 모든 제품은 웰빙엘에스가 연구·제조한 정품이며, 리본바이옴은 온•오프라인 유통과 파트너 서비스를 담당합니다")])], 1)], 1)], 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "w-md-160px",
    attrs: {
      "to": "/about",
      "color": "primary",
      "rounded": "",
      "x-large": ""
    }
  }, [_vm._v("브랜드 이야기")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }